import { render, staticRenderFns } from "./ViewAgents.vue?vue&type=template&id=0f5fe1aa&scoped=true&"
import script from "./ViewAgents.vue?vue&type=script&lang=js&"
export * from "./ViewAgents.vue?vue&type=script&lang=js&"
import style0 from "./ViewAgents.vue?vue&type=style&index=0&id=0f5fe1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5fe1aa",
  null
  
)

export default component.exports